import { Injectable } from "@angular/core"
import { BehaviorSubject, Subject } from "rxjs"

@Injectable()
export class PortraitCaptureHintCardService {
    public hintCard = new Subject<any>();
    public observer: any = this.hintCard.asObservable();
    public data: any = {};
    
}